firebird.controller('attendeeWithEchoDetectedCtrl', [
    '$rootScope',
    '$scope',
    'logService',
    'socketService',
    'localizationService',
    'helperService',
    'attendeeListService',
    function ($rootScope, $scope, logService, socketService, localizationService, helperService, attendeeListService) {
        const self = this;

        const logger = new LogServiceWrapper(logService, 'attendeeWithEchoDetectedCtrl');

        self.attendantName = '';
        self.attendantId = 0;
        self.submitting = false;
        self.modalState = 'closed';

        self.getModalTitle = function () {
            return localizationService.translate('HEADER.SETTINGS.ECHO_DETECTION.DIALOG.TITLE', {
                attendeeName: self.attendantName
            });
        };

        self.muteAttendee = function () {
            const msg = {
                message: 'mute-attendee-with-echo',
                data: {
                    attendantId: self.attendantId
                },
                callback: response => {
                    self.submitting = false;
                    if (!response.result) {
                        logger.error('muteAttendee', 'Muting attendee with echo was not successful', self.attendantId);
                    }
                    self.close();
                }
            };
            self.submitting = true;
            const attendee = attendeeListService.findAttendee(self.attendantId);
            if (!attendee.isSelfMuted) {
                socketService.send(msg);
            } else {
                self.close();
            }
        };

        self.close = () => {
            self.modalState = 'closed';
            resetState();
            if (!helperService.getVDIRef().showContentsOnTopOfVideo) {
                $rootScope.$broadcast('vdi-toggle-preview-video-visibility', false);
            }
        };

        $scope.$on('show-modal', function (e, data) {
            if (data.modalName === 'attendeeWithEchoDetected' && self.modalState !== 'open') {
                resetState();
                self.attendantName = data.attendantName;
                self.attendantId = data.attendantId;
                self.modalState = 'open';
                if (!helperService.getVDIRef().showContentsOnTopOfVideo) {
                    $rootScope.$broadcast('vdi-toggle-preview-video-visibility', true);
                }
            }
        });

        function resetState() {
            self.attendantName = '';
            self.attendantId = 0;
            self.submitting = false;
        }
    }
]);
